import { Component, OnInit } from '@angular/core';
import { FloatPopupService } from 'app/services/float-popup.service';
import { LineGeomEditWizardComponent } from '../line-geom-edit-wizard.component';

@Component({
  selector: 'app-line-geom-edit-wizard-icon',
  templateUrl: './line-geom-edit-wizard-icon.component.html',
  styleUrls: ['./line-geom-edit-wizard-icon.component.css']
})
export class LineGeomEditWizardIconComponent implements OnInit {


	constructor(
		private floatPopupService: FloatPopupService
	) { }

	openMapEdit() {
		this.floatPopupService.openPopup(LineGeomEditWizardComponent);
	}

	ngOnInit() {
	}
}
